import * as THREE from 'three';

export class Effects {
  constructor(scene) {
    this.scene = scene;
    this.bursts = [];
  }

  burst(position, color = '#ffbd62', count = 26, force = 18) {
    const geometry = new THREE.BufferGeometry();
    const points = new Float32Array(count * 3);
    const velocities = [];
    for (let index = 0; index < count; index += 1) {
      velocities.push(new THREE.Vector3(
        (Math.random() - 0.5) * force,
        (Math.random() - 0.2) * force,
        (Math.random() - 0.5) * force
      ));
    }
    geometry.setAttribute('position', new THREE.BufferAttribute(points, 3));
    const material = new THREE.PointsMaterial({
      color,
      size: 2.4,
      transparent: true,
      opacity: 1,
      depthWrite: false,
      blending: THREE.AdditiveBlending
    });
    const particles = new THREE.Points(geometry, material);
    particles.position.copy(position);
    this.scene.add(particles);
    this.bursts.push({ particles, velocities, life: 1, gravity: 5 });
  }

  update(dt) {
    for (let burstIndex = this.bursts.length - 1; burstIndex >= 0; burstIndex -= 1) {
      const burst = this.bursts[burstIndex];
      burst.life -= dt * 1.35;
      const positions = burst.particles.geometry.attributes.position;
      for (let index = 0; index < positions.count; index += 1) {
        const velocity = burst.velocities[index];
        velocity.y -= burst.gravity * dt;
        positions.setXYZ(
          index,
          positions.getX(index) + velocity.x * dt,
          positions.getY(index) + velocity.y * dt,
          positions.getZ(index) + velocity.z * dt
        );
      }
      positions.needsUpdate = true;
      burst.particles.material.opacity = Math.max(0, burst.life);
      burst.particles.material.size = 1.2 + burst.life * 2;
      if (burst.life <= 0) {
        this.scene.remove(burst.particles);
        burst.particles.geometry.dispose();
        burst.particles.material.dispose();
        this.bursts.splice(burstIndex, 1);
      }
    }
  }
}
